import {Button} from "antd";
import styled from 'styled-components'
export const ButtonStyled = styled(Button)`
    display: block;
`